<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Laporan Laba Rugi</h2>

      <br />

      <div class="filter">
        <form @submit.prevent="loadData()">
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
          <button type="submit" class="btn-fill">Filter</button>
          <div></div>
          <button type="button" class="btn-outline green" @click="exportExcel()">
          {{ loadingExcel ? 'Loading...' : 'Export Excel' }}</button>
        </form>
      </div>

      <div class="body">
        <h3>Pemasukan</h3>
        <ul>
          <li>
            <div>Penjualan Tunai</div>
            <div>Rp {{ data.pemasukan.penjualan_tunai | number }}</div>
            <div></div>
          </li>
          <li>
            <div>Penjualan Non Tunai</div>
            <div>Rp {{ data.pemasukan.penjualan_non_tunai | number }}</div>
            <div></div>
          </li>
          <li>
            <div>Paid In</div>
            <div>Rp {{ data.pemasukan.jumlah_paid_in | number }}</div>
            <div></div>
          </li>
          <li>
            <div>Pajak</div>
            <div>Rp {{ data.pemasukan.jumlah_pajak | number }}</div>
            <div></div>
          </li>
          <li>
            <div>Diskon</div>
            <div>-Rp {{ data.pemasukan.jumlah_diskon | number }}</div>
            <div></div>
          </li>
          <li>
            <div>Pembulatan Atas</div>
            <div>Rp {{ data.pemasukan.jumlah_pembulatan_atas | number }}</div>
            <div></div>
          </li>
          <li>
            <div><b>Total Pemasukan</b></div>
            <div>
              <b>Rp {{ data.pemasukan.total | number }}</b>
            </div>
            <div>
              <b>100%</b>
            </div>
          </li>
        </ul>
        <br />
        <h3>Pengeluaran</h3>
        <ul>
          <li>
            <div>Bahan Baku:</div>
            <div></div>
          </li>
          <li style="display: block">
            <div>
              <ul>
                <li
                  v-for="(item, index) in data.pengeluaran
                    .detail_biaya_bahan_baku"
                  :key="index"
                  style="display: flex; justify-content: space-between"
                >
                  <span style="font-weight: 500">
                    {{ index }}
                  </span>
                  <div style="display: grid; grid-template-columns: 1fr 60px">
                    <span>Rp {{ item | number }}</span>
                    <div></div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div style="font-weight: 600">Jumlah pembelian bahan baku</div>
            <div style="font-weight: 600">
              Rp {{ data.pengeluaran.jumlah_biaya_bahan_baku | number }}
            </div>
            <div>
              <b>({{ data.pengeluaran.persen_bahan_baku }}%)</b>
            </div>
          </li>
          <li>&nbsp;</li>
          <li>
            <div>Biaya Karyawan:</div>
            <div></div>
          </li>
          <li>
            <div style="padding-left: 10px">Biaya gaji</div>
            <div>Rp {{ data.pengeluaran.total_gaji | number }}</div>
          </li>
          <li>
            <div style="font-weight: 600">Jumlah BTKL</div>
            <div style="font-weight: 600">
              Rp {{ data.pengeluaran.biaya_gaji | number }}
            </div>
            <div>
              <b>({{ data.pengeluaran.persen_btkl }}%)</b>
            </div>
          </li>
          <li>&nbsp;</li>
          <li>
            <div>Biaya Overhead:</div>
            <div></div>
          </li>
          <li>
            <div style="padding-left: 10px">Pembulatan bawah</div>
            <div>
              Rp {{ Math.abs(data.pemasukan.jumlah_pembulatan_bawah) | number }}
            </div>
          </li>
          <li>
            <div style="padding-left: 10px">Paid Out</div>
            <div>Rp {{ data.pengeluaran.jumlah_paid_out | number }}</div>
          </li>
          <li style="display: block">
            <div>
              <ul style="padding-left: 10px;">
                <li
                  v-for="(item, index) in data.pengeluaran
                    .detail_biaya_overhead"
                  :key="index"
                  style="display: flex; justify-content: space-between"
                >
                  <span style="font-weight: 500">
                    {{ index }}
                  </span>
                  <div style="display: grid; grid-template-columns: 1fr 60px">
                    <span>Rp {{ item | number }}</span>
                    <div></div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li
            v-for="(item, index) in data.pemasukan.komisi_ojekonline"
            :key="index"
          >
            <div style="padding-left: 10px">Komisi {{ index }}</div>
            <div>Rp {{ item | number }}</div>
          </li>
          <li>
            <div style="font-weight: 600">Jumlah Biaya Overhead</div>
            <div style="font-weight: 600">
              Rp {{ data.pengeluaran.jumlah_biaya_overhead | number }}
            </div>
            <div>
              <b>({{ data.pengeluaran.persen_overhead }}%)</b>
            </div>
          </li>
          <li>&nbsp;</li>
          <li>
            <div><b>Jumlah HPP</b></div>
            <div>
              <b>Rp {{ data.pengeluaran.jumlah_hpp | number }} </b>
            </div>
            <div>
              <b>({{ data.pengeluaran.persen_hpp }}%)</b>
            </div>
          </li>
        </ul>

        <br />
        <div class="laba">
          <h3>Laba</h3>
          <h3>Rp {{ data.laba_rugi.jumlah | number }}</h3>
          <h3>({{ data.laba_rugi.persen }}%)</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "../../api/Api";
import moment from "moment";

export default {
  name: "Home",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      loadingExcel: false,
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-D"),
      },
      tahun: [],
      data: {
        pemasukan: {},
        pengeluaran: {},
        laba_rugi: {},
      },
    };
  },
  methods: {
    moment,
    getTahunAwal() {
      api
        .get("/v4/penjualan/first-year?id_toko=" + this.$toko.id)
        .then((res) => {
          this.tahun = res.data;
        });
    },
    loadData() {
      setTimeout(() => {
        this.filter.id_toko = this.$toko.id;

        this.filter.tgl_awal = moment(this.dateRange.startDate).format('YYYY-MM-DD');
        this.filter.tgl_akhir = moment(this.dateRange.endDate).format('YYYY-MM-DD');

        this.loading = true;
        this.filterOpen = false;
        api
          .get("/v4/laporan/laba-rugi?" + this.$objectToQuery(this.filter))
          .then((r) => {
            this.loading = false;
            this.data.pemasukan = r.data.pemasukan;
            this.data.pengeluaran = r.data.pengeluaran;
            this.data.laba_rugi = r.data.laba_rugi;
          })
          .catch((err) => {
            this.loading = false;
            this.$toast("Gagal mengambil data");
          });
      }, 150);
    },
    exportExcel() {
      this.loadingExcel = true;
      api
        .postJson(
          "https://app.restoku.id/exporter/labaRugi?id_toko=" +
            this.$toko.id +
            "&title=Laporan Laba / Rugi" +
            "&tgl_awal=" +
            this.filter.tgl_awal +
            "&tgl_akhir=" +
            this.filter.tgl_akhir,
          this.data
        )
        .then((r) => {
          if (r.valid) {
            location.href = r.url;
          }

          this.loadingExcel = false;
        })
        .catch((e) => {
          this.$toast("Terjadi kesalahan");
          this.loadingExcel = false;
        });

      console.log(this.data);
    },
  },
  mounted() {
    this.getTahunAwal();
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    form {
      display: grid;
      grid-template-columns: 300px 150px 1fr 150px;
      grid-column-gap: 20px;
    }
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }

  .body {
    padding: 20px;
    h3 {
      font-size: 16px;
    }
    ul {
      list-style-type: none;
      padding-left: 20px;
      margin: 0;
      li {
        display: grid;
        grid-template-columns: 1fr 1fr 60px;
        margin: 10px 0;
        font-size: 14px;

        > div {
          &:nth-child(2),
          &:nth-child(3) {
            text-align: right;
          }
        }
        &.line {
          border-top: 1px solid #999;
        }
        &.sub {
          color: #999;
          padding-left: 5px;
        }
      }
    }
    .laba {
      display: grid;
      grid-template-columns: 1fr 1fr 60px;
      h3 {
        &:nth-child(2),
        &:nth-child(3) {
          text-align: right;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/laporan/LabaRugi.vue